import React, { useState } from "react";
import TableAction from "../../components/TableAction";
import WithAuth from "../../hoc/WithAuth";
import ProductsTable from "../../components/product/ProductTable";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import AdminProductModal from "./AdminProductModal";

function ProductsPage() {
  const [searchText, setSearchText] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);
  const { user } = useAuth() as AuthContextValue;

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div
      className="bg-transparent px-2 md:bg-white md:px-[50px]"
      style={{
        borderRadius: 8.5,
        marginTop: 25,
      }}
    >
      {/* <AdminProductModal open={open} selectedId={selectedId} hideModal={hideModal} />
            <div style={{ display: 'flex', alignItems: 'center', height: 80, backgroundColor: '#EEF3F8', borderRadius: 8.4, marginBottom: 12 }}>
                <TableAction setSearchText={setSearchText} onCreateNew={ user?.roleName === 'ROLE_KFT_SUPER_ADMIN' ? handleCreate : undefined} />
            </div> */}

      <ProductsTable searchTexts="" />
    </div>
  );
}

export default WithAuth(ProductsPage);
